import {
    CHANGE_PAGE,
    DISMISS_ERROR,
    DISMISS_LOADING_SUCCEEDED,
    LOGOUT_FAILED,
    LOGOUT_SUCCEEDED,
    SET_ERROR,
    SET_LOADING_SUCCEEDED,
    IS_LOADING
} from '../constants/actionTypes';

const initialState = {
    error:            null,
    loading:          false,
    loadingSucceeded: null,
    route:            { page: 'seasons' }
};

const reducer = ( state = initialState, action ) => {

    // console.log( 'reducers.app', state, action );

    switch ( action.type ) {

        case CHANGE_PAGE: {

            const { route } = action.payload;

            return { ...state, route };

        }

        case DISMISS_ERROR: {

            return { ...state, error: null };

        }

        case DISMISS_LOADING_SUCCEEDED: {

            return { ...state, loadingSucceeded: null };

        }

        case IS_LOADING: {

            const { loading } = action.payload;

            return { ...state, loading };

        }

        case SET_LOADING_SUCCEEDED: {

            return { ...state, loadingSucceeded: action.payload.type };

        }

        case LOGOUT_FAILED:
        case LOGOUT_SUCCEEDED: {

            return initialState;

        }

        case SET_ERROR: {

            const { error } = action.payload;

            return { ...state, error };

        }

        default:

            return state;

    }

};

export default reducer;